import { Modal, Row, Col, Badge } from "react-bootstrap";
import "./components.css";
import CommonButton from "./CommonButton";

const teamData = [
  {
    role: "Fronted Developer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
  {
    role: "Backend Developer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
  {
    role: "UI Designer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
  {
    role: "Fronted Developer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
  {
    role: "Backend Developer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
  {
    role: "UI Designer",
    rate: "$20/hr",
    description:
      "Frontend Developer specializing in responsive, user-friendly web interfaces.",
    seniority: "Senior",
    tags: ["Cross-platform", "Web", "Desktop"],
  },
];

const RateCardModal = ({ show, onHide, teamRoleDetails }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      size="xl"
      className="team-modal exit-confirmation-modal"
    >
      <Modal.Header closeButton style={{background: '#fff', zIndex: 1}}>
        <Modal.Title>
          <h3 className="com-title p-0 m-0" style={{ fontSize: "20px" }}>
            Team <span className="primary-color">Rate</span> Card
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="g-4" style={{ maxHeight: "500px", overflow: "auto" }}>
          {teamRoleDetails?.length > 0 &&
            teamRoleDetails?.map((member, idx) => (
              <Col md={4} sm={6} key={idx}>
                <div className="p-3 rate-box h-100">
                  <div className="d-flex justify-content-between align-items-start">
                    <strong className="text-capitalize">
                      {member?.role_name ?? "-"}
                    </strong>
                    <span className="primary-color fw-bold">
                      ${member?.rate_per_hour}/hr
                    </span>
                  </div>
                  <p className="mt-2 mb-2 small">
                    {member?.short_description ?? "-"}
                  </p>
                  <p className="mb-1 fw-semibold" style={{ fontSize: "16px" }}>
                    Seniority :{" "}
                    <span className="primary-color text-capitalize">
                      {member?.experience_levels ?? "-"}
                    </span>
                  </p>
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    {member?.technical_tags?.length > 0 &&
                      member?.technical_tags.map((tag, tIdx) => (
                        <Badge
                          bg="light"
                          text="dark"
                          key={tIdx}
                          className="tech-badge"
                        >
                          {tag?.title}
                        </Badge>
                      ))}
                  </div>
                </div>
              </Col>
            ))}
        </Row>

        <div className="d-flex justify-content-end gap-3 mt-4">
          <CommonButton
            label="Close"
            className="black-border"
            variant="outline"
            onClick={onHide}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RateCardModal;
